import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'


export const useFundraiserInvitePublicStore = defineStore('fundraiserInvitePublic', {
  id: 'fundraiserInvitePublic',
  state: () => ({
    items: [],
    api: '/api/v1/fundraiser-invites-public'
  }),
  getters: {
    ...getters
  },
  actions: {
    ...actions
  }
})
